import { DecimalPipe, UpperCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { BezugsrechtBackLinkComponent } from '../back-link/bezugsrecht-back-link.component';
import { BezugsrechtBase } from '../bezugsrecht.base';

@Component({
  imports: [TranslocoPipe, RouterLink, BezugsrechtBackLinkComponent, DecimalPipe, ButtonComponent, UpperCasePipe],
  templateUrl: './bezugsrecht-sell.component.html',
})
export class BezugsrechtSellComponent extends BezugsrechtBase {
  public openSellNewTab() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree([this.commonRoutes.postlogin.buyAndSell], {
        queryParams: {
          isin: this.model.asset.isin,
          direction: 'sell',
          quantity: this.model.announcement.bzrVerfuegbar,
        },
      }),
    );
    window.open(url, '_blank');
  }
}
